import { Injectable, EventEmitter, HostListener, Output } from '@angular/core'
import { webSocket, WebSocketSubject } from 'rxjs/webSocket'
import { environment } from 'src/environments/environment.test'
import { interval, Observable, Subject } from 'rxjs'
import { v4 as uuidv4 } from 'uuid'

@Injectable({
  providedIn: 'root',
})
export class WebsocketService {
  test: string
  uuid: string
  windowHasFocus = true
  isActivated = false
  isAuthenticated = false
  private subscription
  pingCount = 0
  socket: WebSocketSubject<any>
  PING_INTERVAL_SECONDS = 20
  constructor() {
    this.uuid = uuidv4()
  }
  //Observable string source
  private webSocketSource = new Subject<string>()
  //Obserable string stream
  webSocketData$ = this.webSocketSource.asObservable()
  //Service mesage command
  messageSend(msg: any) {
    this.webSocketSource.next(msg)
  }

  initWebsocket() {
    if (this.isActivated) return
    this.isActivated = true

    //Change websocket gate for different websocket
    this.socket = webSocket({
      url: environment.websocketGate,
      deserializer: (msg) => msg,
      openObserver: {
        next: () => {},
      },
    })
    this.pingCount = 0
    this.Authenticate()
    this.connect()
  }

  connect() {
    this.socket.subscribe(
      (msg) => {
        if (msg.data == 'Pong') {
          //;
          this.pingCount = 0
        } else {
          this.messageSend(msg.data)
        }
      },
      (err) => {
        this.isActivated = false
        console.error('err: ' + JSON.stringify(err)) // Called if at any point WebSocket API signals some kind of error.
      },
      () => {
        this.isActivated = false // Called when connection is closed (for whatever reason).
      },
    )
  }

  disconnect() {
    if (this.subscription) this.subscription.unsubscribe()
    this.isAuthenticated = false
  }
  //Keep alive
  startPingInterval() {
    this.ping()
    if (this.subscription && !this.subscription.closed) return
    this.subscription = interval(this.PING_INTERVAL_SECONDS * 1000).subscribe(() => this.ping())
  }

  ping() {
    //;
    if (this.pingCount < 1) {
      this.pingCount++
      this.socket.next({
        Type: 'Ping',
      })
    } else {
      if (this.windowHasFocus) {
        this.unsubscribeWebsocket()
        this.initWebsocket()
      } else {
        this.disconnect()
      }
    }
  }

  unsubscribeWebsocket() {
    this.socket.unsubscribe()
    this.isActivated = false
  }

  public Authenticate() {
    if (!this.isAuthenticated) {
      this.socket.next({
        UserId: '33eee6ff-29e0-43e1-8a4e-b25a81ae1c14',
        DeviceId: this.uuid,
        Type: 'Flow',
        Context: 'AG.Flow',
      })
      this.isAuthenticated = true
    }
  }
  ngOnDestroy() {
    this.disconnect()
  }
}
